export default __webpack_public_path__ + "static/media/1859.8796c4ef.png";